import axios from 'axios'

const api = () => {
  return axios.create({
    baseURL: process.env.API_ENDPOINT
  })
}
const state = {
  collections: [],
  collection: [],
  collectionsLive: []
}

const mutations = {
  UPDATE_COLLECTIONS (state, payload) {
    state.collections = payload
  },
  UPDATE_COLLECTIONS_LIVE (state, payload) {
    state.collectionsLive = payload
  },
  UPDATE_COLLECTION_NAME (state, payload) {
    state.collection.Name = payload
  },
  UPDATE_COLLECTION_DEAD (state, payload) {
    state.collection.Dead = payload
  },
  UPDATE_COLLECTION_REGION (state, payload) {
    state.collection.Region = payload
  },
  GET_COLLECTION (state, payload) {
    state.collection = payload
  },
  CLEAR_COLLECTION (state) {
    state.collection = []
  }
}

const actions = {
  getCollections (context, payload) {
    return new Promise((resolve, reject) => {
      api().get('collections').then((response) => {
        context.commit('UPDATE_COLLECTIONS', response.data.collections)
        resolve(response)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCollectionsLive ({ commit }) {
    return new Promise((resolve, reject) => {
      api().get('collections')
        .then((response) => {
          let live = response.data.collections.filter((live) => live.Dead === false)
          commit('UPDATE_COLLECTIONS_LIVE', live)
          resolve(response)
        }, (error) => {
          reject(error)
        })
    })
  },
  getCollection ({ commit }, coll) {
    let collAdd = 'collection/' + coll
    api().get(collAdd)
      .then((response) => {
        commit('GET_COLLECTION', response.data.collection)
      }).then()
  },
  addCollection (context, payload) {
    return new Promise((resolve, reject) => {
      api().post('collection', { Name: payload, Region: 'UK' }).then((response) => {
        resolve(response)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateCollection (context, payload) {
    return new Promise((resolve, reject) => {
      let collAdd = 'collection/update/' + payload._id
      api().put(collAdd, payload)
        .then((response) => {
          resolve(response)
        }, (error) => {
          reject(error)
        })
    })
  },
  deleteCollection (context, payload) {
    return new Promise((resolve, reject) => {
      let collAdd = 'collection/delete/' + payload
      api().delete(collAdd, payload)
        .then((response) => {
          resolve(response)
        }, (error) => {
          reject(error)
        })
    })
  }

}

const getters = {
  collections: state => state.collections,
  collection: state => state.collection,
  collectionsLive: state => state.collectionsLive
}

const collectionModule = {
  state,
  mutations,
  actions,
  getters
}

export default collectionModule
